export default __webpack_public_path__ + "static/media/generali-logo-white.66fbd76f.png";